import type { LinksFunction } from '@remix-run/node';

import styles from './dboo-think-you-are-safe.css?url';

export const links: LinksFunction = () => [{ rel: 'stylesheet', href: styles }];

const NUMBERS_WITH_COMMA = [2, ',', 8, 9, 2, ',', 3, 0, 4, ',', 5, 6, 7];

export const DbooThinkYouAreSafe = () => {
  return (
    <div className="dboo-think-you-are-safe">
      <div className="container">
        <div className="dboo-think-you-are-safe__numbers">
          {NUMBERS_WITH_COMMA.map((text, index) =>
            text === ',' ? (
              <span
                key={`${text}-${index}`}
                className="dboo-think-you-are-safe__comma"
              >
                {text}
              </span>
            ) : (
              <p
                key={`${text}-${index}`}
                className="dboo-think-you-are-safe__single-number"
              >
                {text}
              </p>
            ),
          )}
        </div>
        <h2 className="dboo-think-you-are-safe__title">
          Think you’re safe? Not with data brokers.
        </h2>
        <p className="dboo-think-you-are-safe__description">
          In 2024, hackers stole nearly{' '}
          <strong className="dboo-think-you-are-safe__description--strong">
            2.9 billion records
          </strong>{' '}
          from just one data broker. The less they know about you, the better.
        </p>
      </div>
    </div>
  );
};
